import React, { Component, Fragment } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ChartCard from './components/cards/ChartCard';
import CompendiumCard from './components/cards/CompendiumCard';
import classnames from 'classnames';
import { NavItem, CardHeader, TabContent, TabPane, Nav, NavLink } from 'reactstrap';
import { Colxx, Separator } from '../../../components/common/CustomBootstrap';
import IntlMessages from '../../../helpers/IntlMessages';
// import { NavLink } from 'react-router-dom';
import {
  postAPI_TrackEvent,
  gAPI_Invitation_By_Email,
  gAPI_Users_By_Id,
  gAPI_Check_Invitation,
  API_Ingetration,
  gAPI_Internal_Property_By_Id
} from '../../../constants/APIs';
import { AxiosAPI, getGroupID, getUserID } from '../../../helpers/AxiosAPI';
import ReviewVoucher from './components/ReviewVoucher';
import WordClouds from './components/cards/WordCloud';
import SpaceBookingCard from './components/cards/SpaceBookingCard';
import EmailStats from './components/cards/EmailStats';
import VoiceStats from './components/cards/VoiceStats';
import DetailedDataCard from './components/cards/DetailedDataCard';
const style_css = `.nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
  top:auto !important;
  bottom: 0 !important;
}
.nav-tabs .nav-link.active {
  background-color: transparent;
}`;
class DashboardAnalytics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vouchers: [],
      reviewVoucher: false,
      isAciveTab: 'AiChatbot',
      isComendiumConnect: false,
      isSpaceBooking: false,
      emailIntegrtions: [],
      voiceIntegrations: [],
      hideStats: { isRegionalLevel: false, isHourlyConversation: false }
    };
  }
  componentDidMount() {
    try {
      var time = localStorage.getItem('time');
      var val = false;
      if (time === null) val = true;
      else {
        var date1 = new Date(time);
        var date2 = new Date();
        var Difference_In_Time = date2.getTime() - date1.getTime();
        var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
        if (parseInt(Difference_In_Days) === 1) {
          val = true;
        }
      }
    } catch { }
    if (this.props.email !== '') {
      AxiosAPI({
        method: 'post',
        url: `${postAPI_TrackEvent} `,
        data: {
          eventName: 'Dashboard Insights',
          email: this.props.email,
        },
      }).then(
        (res) => { },
        (error) => {
          console.log(error);
        }
      );
    }
    try {
      AxiosAPI({
        method: 'post',
        url: `${API_Ingetration}/ids?group_id=${getGroupID()}`,
      }).then((res) => {
        var integrationIds = [];
        var list = res.data.filter(
          (i) =>
            i.channel !== 'VoucherWebsite' &&
            i.channel !== 'VoucherStandAlonePage' &&
            i.channel !== 'VoucherHostedPage' &&
            i.channel !== 'EmbedVoucher'
        );
        list.map((k) => {
          if (this.props.propertyId === '-1') {
            integrationIds.push({ id: k.id, channel: k.channel });
          } else {
            if (
              k.properties?.filter((f) => f === this.props.propertyId).length >
              0
            ) {
              integrationIds.push({ id: k.id, channel: k.channel });
            }
          }
        });
        this.setState({ integrationId: integrationIds });
        var voice = list.filter((i) => i.channel === 'PhoneSuite');
        if (voice.length > 0) {
          if (
            voice.filter((i) => i.properties?.includes(this.props.propertyId))
              .length > 0
          ) {
            this.setState({
              voiceIntegrations: voice.filter((i) =>
                i.properties?.includes(this.props.propertyId)
              ),
            });
          }
        }
        var service = list.filter((i) => i.channel === 'ServiceStandAlonePage');
        if (service.length > 0) {
          if (
            service.filter((i) => i.properties?.includes(this.props.propertyId))
              .length > 0
          ) {
            this.setState({ isComendiumConnect: true });
          }
        }
        var spaceStandalone = list.filter(
          (i) => i.channel === 'SpaceStandalone'
        );
        if (spaceStandalone.length > 0) {
          if (
            spaceStandalone.filter((i) =>
              i.properties?.includes(this.props.propertyId)
            ).length > 0
          ) {
            this.setState({ isSpaceBooking: true });
          }
        }
        if (this.props.propertyId === '-1') {
          var emailIntegrtions = res.data.filter(
            (i) => i.channel === 'EmailDirectLine' && i.disabled !== true
          );
          this.setState({ emailIntegrtions: emailIntegrtions });
        } else {
          var emailIntegrtions = res.data.filter(
            (i) =>
              i.channel === 'EmailDirectLine' &&
              i.properties?.includes(this.props.propertyId) > 0 &&
              i.disabled !== true
          );
          this.setState({ emailIntegrtions: emailIntegrtions });
        }

        this.setState({ isAciveTab: 'AiChatbot' });
      });
    } catch {
      this.setState({ integrationId: [] });
    }
    if (this.props.propertyId !== undefined && this.props.propertyId !== null && this.props.propertyId !== "-1") {
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Internal_Property_By_Id}/${this.props.propertyId}?group_id=${getGroupID()}`
      }).then((res) => {
        if (res.data.hideStats !== null) {
          this.setState({
            hideStats: {
              isHourlyConversation: res.data.hideStats.isHourlyConversation,
              isRegionalLevel: res.data.hideStats.isRegionalLevel
            }
          });
        }
      });
    }
  }

  render() {
    const { messages } = this.props.intl;
    return (
      <Fragment>
        <CardHeader
          className="mb-0"
          style={{ marginLeft: '-1.22rem', marginRight: '-1.22rem' }}
        >
          <Nav tabs className="card-header-tabs separator-tabs mb-1 ml-0 mr-0">
            <style>{style_css}</style>
            <NavItem
              className="text-center"
              style={{ width: 'auto', background: '' }}
            >
              <NavLink
                style={{ background: 'none', cursor: 'pointer' }}
                className={classnames({
                  active: this.state.isAciveTab === 'AiChatbot',
                  'nav-link': true,
                })}
                onClick={() => {
                  this.setState({ isAciveTab: 'AiChatbot' });
                }}
                to="#"
              >
                <span
                  style={{
                    color: `${this.state.isAciveTab === 'AiChatbot'
                      ? 'var(--theme-color-1)'
                      : '#8f8f8f'
                      }`,
                    fontWeight: 600,
                  }}
                >
                  <IntlMessages id="dashboards.ai-chatbot" />
                </span>
              </NavLink>
            </NavItem>
            {this.state.isComendiumConnect === true && (
              <NavItem className="text-center" style={{ width: 'auto' }}>
                <NavLink
                  style={{ background: 'none', cursor: 'pointer' }}
                  className={classnames({
                    active: this.state.isAciveTab === 'Compendium',
                    'nav-link': true,
                  })}
                  onClick={() => {
                    this.setState({ isAciveTab: 'Compendium' });
                  }}
                  to="#"
                >
                  <span
                    style={{
                      color: `${this.state.isAciveTab === 'Compendium'
                        ? 'var(--theme-color-1)'
                        : '#8f8f8f'
                        }`,
                      fontWeight: 600,
                    }}
                  >
                    {' '}
                    <IntlMessages id="dashboards.compendium" />
                  </span>
                </NavLink>
              </NavItem>
            )}
            {this.state.isSpaceBooking === true && (
              <NavItem
                className="text-center"
                style={{ width: 'auto', background: '' }}
              >
                <NavLink
                  style={{ background: 'none', cursor: 'pointer' }}
                  className={classnames({
                    active: this.state.isAciveTab === 'space',
                    'nav-link': true,
                  })}
                  onClick={() => {
                    this.setState({ isAciveTab: 'space' });
                  }}
                  to="#"
                >
                  <span
                    style={{
                      color: `${this.state.isAciveTab === 'space'
                        ? 'var(--theme-color-1)'
                        : '#8f8f8f'
                        }`,
                      fontWeight: 600,
                    }}
                  >
                    {' '}
                    <IntlMessages id='dashboards.space-booking' />
                  </span>
                </NavLink>
              </NavItem>
            )}
            <NavItem
              className="text-center"
              style={{ width: 'auto', background: '' }}
            >
              <NavLink
                style={{ background: 'none', cursor: 'pointer' }}
                className={classnames({
                  active: this.state.isAciveTab === 'Word Cloud',
                  'nav-link': true,
                })}
                onClick={() => {
                  this.setState({ isAciveTab: 'Word Cloud' });
                }}
                to="#"
              >
                <span
                  style={{
                    color: `${this.state.isAciveTab === 'Word Cloud'
                      ? 'var(--theme-color-1)'
                      : '#8f8f8f'
                      }`,
                    fontWeight: 600,
                  }}
                >
                  {' '}
                  <IntlMessages id='dashboards.wordCloud' />
                </span>
              </NavLink>
            </NavItem>

            {this.state.emailIntegrtions.length > 0 && (
              <NavItem
                className="text-center"
                style={{ width: 'auto', background: '' }}
              >
                <NavLink
                  style={{ background: 'none', cursor: 'pointer' }}
                  className={classnames({
                    active: this.state.isAciveTab === 'emails',
                    'nav-link': true,
                  })}
                  onClick={() => {
                    this.setState({ isAciveTab: 'emails' });
                  }}
                  to="#"
                >
                  <span
                    style={{
                      color: `${this.state.isAciveTab === 'emails'
                        ? 'var(--theme-color-1)'
                        : '#8f8f8f'
                        }`,
                      fontWeight: 600,
                    }}
                  >
                    {' '}
                    Email
                  </span>
                </NavLink>
              </NavItem>
            )}
            {this.state?.voiceIntegrations &&
              this.state?.voiceIntegrations.length > 0 && (
                <NavItem
                  className="text-center"
                  style={{ width: 'auto', background: '' }}
                >
                  <NavLink
                    style={{ background: 'none', cursor: 'pointer' }}
                    className={classnames({
                      active: this.state.isAciveTab === 'Voice',
                      'nav-link': true,
                    })}
                    onClick={() => {
                      this.setState({ isAciveTab: 'Voice' });
                    }}
                    to="#"
                  >
                    <span
                      style={{
                        color: `${this.state.isAciveTab === 'Voice'
                          ? 'var(--theme-color-1)'
                          : '#8f8f8f'
                          }`,
                        fontWeight: 600,
                      }}
                    >
                      {' '}
                      AI Voice
                    </span>
                  </NavLink>
                </NavItem>
              )}
            {this.state.hideStats.isHourlyConversation === true || this.state.hideStats.isRegionalLevel === true ?
              <NavItem
                className="text-center"
                style={{ width: 'auto', background: '' }}
              >
                <NavLink
                  style={{ background: 'none', cursor: 'pointer' }}
                  className={classnames({
                    active: this.state.isAciveTab === 'detailed-data',
                    'nav-link': true,
                  })}
                  onClick={() => {
                    this.setState({ isAciveTab: 'detailed-data' });
                  }}
                  to="#"
                >
                  <span
                    style={{
                      color: `${this.state.isAciveTab === 'detailed-data'
                        ? 'var(--theme-color-1)'
                        : '#8f8f8f'
                        }`,
                      fontWeight: 600,
                    }}
                  >
                    {' '}
                    Detailed Data
                  </span>
                </NavLink>
              </NavItem>
              : null}
          </Nav>
        </CardHeader>

        <TabContent activeTab={this.state.isAciveTab} className="">
          <TabPane
            tabId="AiChatbot"
            className="chat-app-tab-pane"
            style={{ width: 'auto', background: 'transparent' }}
          >
            {this.state.integrationId !== undefined && this.state.isAciveTab === "AiChatbot" && (
              <ChartCard
                propertyId={this.props.propertyId}
                timeZone={this.props.timeZone}
                domains={this.props.domains}
                isVoucherEngine={this.props.isVoucherEngine}
                currency={this.props.currency}
                history={this.props.history}
                integrationIdList={this.state.integrationId
                  .filter((l) => l.channel !== 'ServiceStandAlonePage')
                  .map((i) => i.id)}

              />
            )}
          </TabPane>
          <TabPane
            tabId="Voice"
            className="chat-app-tab-pane"
            style={{ width: 'auto', background: 'transparent' }}
          >
            {this.state?.voiceIntegrations &&
              this.state?.voiceIntegrations.length > 0 && this.state.isAciveTab === "Voice" && (
                <VoiceStats
                  propertyId={this.props.propertyId}
                  timeZone={this.props.timeZone}
                  domains={this.props.domains}
                  isVoucherEngine={this.props.isVoucherEngine}
                  currency={this.props.currency}
                  history={this.props.history}
                  integrationIdList={this.state?.voiceIntegrations.map(
                    (i) => i.id
                  )}
                />
              )}
          </TabPane>
          <TabPane
            tabId="detailed-data"
            className="chat-app-tab-pane"
            style={{ width: 'auto', background: 'transparent' }}
          >
            {this.state.integrationId !== undefined && this.state.isAciveTab === "detailed-data" && (
              <DetailedDataCard
                propertyId={this.props.propertyId}
                hideStats={this.state.hideStats}
                timeZone={this.props.timeZone}
                domains={this.props.domains}
                isVoucherEngine={this.props.isVoucherEngine}
                currency={this.props.currency}
                history={this.props.history}
                integrationIdList={this.state.integrationId
                  .filter((l) => l.channel !== 'ServiceStandAlonePage')
                  .map((i) => i.id)}
              />
            )}
          </TabPane>
        </TabContent>
        <TabContent activeTab={this.state.isAciveTab} className="">
          <TabPane tabId="Compendium" className="chat-app-tab-pane">
            {this.state.integrationId !== undefined &&
              this.state.integrationId.length > 0 &&
              this.state.isComendiumConnect === true && this.state.isAciveTab === "Compendium" && (
                <CompendiumCard
                  propertyId={this.props.propertyId}
                  timeZone={this.props.timeZone}
                  domains={this.props.domains}
                  isVoucherEngine={this.props.isVoucherEngine}
                  currency={this.props.currency}
                  history={this.props.history}
                  integrationIdList={this.state.integrationId
                    .filter((l) => l.channel === 'ServiceStandAlonePage')
                    .map((i) => i.id)}
                ></CompendiumCard>
              )}
          </TabPane>
        </TabContent>
        <TabContent activeTab={this.state.isAciveTab} className="">
          <TabPane tabId="space" className="chat-app-tab-pane">
            {this.state.integrationId !== undefined &&
              this.state.integrationId.length > 0 &&
              this.state.isSpaceBooking === true && this.state.isAciveTab === "space" && (
                <SpaceBookingCard
                  propertyId={this.props.propertyId}
                  timeZone={this.props.timeZone}
                  domains={this.props.domains}
                  isVoucherEngine={this.props.isVoucherEngine}
                  currency={this.props.currency}
                  history={this.props.history}
                  integrationIdList={this.state.integrationId
                    .filter((l) => l.channel === 'SpaceStandalone')
                    .map((i) => i.id)}
                ></SpaceBookingCard>
              )}
          </TabPane>
        </TabContent>
        <TabContent activeTab={this.state.isAciveTab} className="">
          <TabPane tabId="Word Cloud" className="chat-app-tab-pane">
            {this.state.isAciveTab === "Word Cloud" &&
              <WordClouds
                propertyId={this.props.propertyId}
                timeZone={this.props.timeZone}
                domains={this.props.domains}
                isVoucherEngine={this.props.isVoucherEngine}
                currency={this.props.currency}
                history={this.props.history}
                isComendiumConnect={this.state.isComendiumConnect}
                integrationIdList={
                  this.state?.integrationId &&
                  this.state.integrationId
                    .filter((l) => l.channel === 'ServiceStandAlonePage')
                    .map((i) => i.id)
                }
              ></WordClouds>
            }
          </TabPane>
          <TabPane tabId="emails" className="chat-app-tab-pane">
            {this.state.emailIntegrtions.length > 0 && this.state.isAciveTab === "emails" && (
              <EmailStats
                timeZone={this.props.timeZone}
                emailIntegrtions={this.state.emailIntegrtions}
                propertyId={this.props.propertyId}
              ></EmailStats>
            )}
          </TabPane>
        </TabContent>

        {this.state.reviewVoucher !== undefined && this.state.reviewVoucher && (
          <ReviewVoucher
            visible={this.state.reviewVoucher}
            hideModal={() => {
              this.setState({ reviewVoucher: !this.state.reviewVoucher });
            }}
          ></ReviewVoucher>
        )}
        {/* <Row> */}
        {/* <Colxx xl="4" lg="6" md="12" className="mb-4"> */}
        {/* <ProductCategoriesDoughnut /> */}
        {/* </Colxx>
          <Colxx xl="4" lg="6" md="12" className="mb-4"> */}
        {/* <ProfileStatuses cardClass="dashboard-progress" /> */}
        {/* </Colxx>
          <Colxx xl="4" lg="12" md="12">
            <SmallLineCharts itemClass="dashboard-small-chart-analytics" />
          </Colxx>
        </Row>

        <SortableStaticticsRow messages={messages} />

        <Row>
          <Colxx xxs="12" lg="6" className="mb-4">
            <OrderStockRadarChart />
          </Colxx>
          <Colxx xxs="12" lg="6" className="mb-4">
            <ProductCategoriesPolarArea />
          </Colxx>
        </Row>

        <Row>
          <Colxx xxs="12" className="mb-4">
            <SalesChartCard />
          </Colxx>
        </Row> */}
      </Fragment>
    );
  }
}

const mapStateToProps = ({ authUser, settings, oidc }) => {
  const { user: loginUser } = authUser;
  const {
    locale,
    propertyId,
    isVoucherEngine,
    timeZone,
    email,
    domains,
    currency,
  } = settings;
  //console.log(settings);
  return {
    loginUser,
    locale,
    oidc,
    isVoucherEngine,
    propertyId,
    timeZone,
    email,
    domains,
    currency,
  };
};

const mapActionsToProps = {};

const aap = injectIntl(DashboardAnalytics);
export default connect(mapStateToProps, mapActionsToProps)(aap);
